import LocalStorageWrapper from '~/lib/LocalStorageWrapper'

const storage = new LocalStorageWrapper()

export const getLocalStorageItem = (key: string) => storage.getItem(key)

export const setLocalStorageItem = (key: string, value: string | boolean) =>
    storage.setItem(key, value)
